module.exports = __webpack_public_path__ + "static/media/service2.0224d29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/service2.png
// module id = 3406
// module chunks = 0